import { TrainerPayrollState } from './types';

export const state = (): TrainerPayrollState => initialState();

export const initialState = (): TrainerPayrollState => ({
  trainerPayrolls: {
    items: [],
    isLoading: false,
    total: 0,
    searchParams: {
      dataOption: {
        page: 1,
        itemsPerPage: 10,
        sortBy: ['trainerFullName'],
        sortDesc: [false],
        groupBy: [],
        groupDesc: [],
        multiSort: true,
        mustSort: false,
      },
      filter: '',
      orClauseFieldsIds: ['trainerFullName', 'courseName', 'costCenter'],
    },
  },
});
